import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { useEffect, useState } from "react"
import styled from "styled-components"
import { useScrollLock } from "../../hooks/useScrollLock"
import { showModal } from "../../features/modal/modalSlice"
import { handleActiveSelect } from "../../features/layout/layoutSlice"
import PageTopTitle from "../shared/PageTopTitle"
import Btn from "../shared/button/Btn"
import { deleteBlockedUsers } from "../../features/blockedUsers/blockedUserSlice"



const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 600px;
        height: 300px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-block: 20px;
        border-radius: 10px;
        margin: 0 auto;
        .content{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100%;
        }
        .inputs{
            padding: 10px 0px;
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 15px;
            justify-content: center;
            align-items: center;
        }
    }


`



const FirmaKaraListeOptionModal = () => {
    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();
    const {selectedBlockedUser} = useSelector((state) => state.blockedUsers)

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    return (
    <ModalContainer onClick={()=> {dispatch(showModal(null));}}>
        <div className="modal" onClick={(e) => { e.stopPropagation(); dispatch(handleActiveSelect(null)) }}>
            <PageTopTitle isDiffPage title={"Engellenen Sürücüler"}/>
            <div className="content">
                <div onClick={(e) =>{ e.stopPropagation(); }} className="inputs">
                    <Btn bgColor="#fff" width="300px"  handleClick={() => {dispatch(deleteBlockedUsers(selectedBlockedUser?.id))}} color="#E85446">Engeli Kaldır</Btn>
                    <Btn bgColor="#fff" width="300px" handleClick={() => {dispatch(showModal(null))}} color="#E85446">Kapat</Btn>
                </div>
            </div>
            
            
        </div>
    </ModalContainer>
  )
}

export default FirmaKaraListeOptionModal